module.exports = __webpack_public_path__ + "static/media/team-member-02.dcce6a79.jpg";